import * as React from "react";
import { css, Stack, Dialog, DialogType, Spinner, SpinnerSize, IDropdownOption } from "office-ui-fabric-react";
import { IUserAccount } from "../LoginComponent/LoginComponent";
import { IAccessRequest } from "../../Models/IAccessRequest";
import "./../../Styles/Access.scss";

import ReCAPTCHA from "react-google-recaptcha";

import { cloneDeep } from "lodash";
import { AccessRequestSchema } from "../../Models/Constant";
import { IDataProvider } from "../../dataprovider/IDataProvider";
import { IAskAccess } from "../../Models/IAskAccess";
import { RequesterData } from "../RequesterData/RequesterData";
import { CaptchaAndSubmitAction } from "../RequestCaptchaAndSubmitAction/RequestCaptchaAndSubmitAction";
import { PageURL } from "../../App";
export interface IAskAccessProps {
  location: Location;
  history: any;
  stepSizeClass: string;
  isLoggedIn: boolean;
  dataProvider: IDataProvider;
  currentUser?: IUserAccount;
}

export interface IAskAccessState {
  isLoggedIn: boolean;
  data: any;
}

export const AskAccess = (props: IAskAccessProps) => {
  const [data, setData] = React.useState<IAskAccess>(AccessRequestSchema);
  const [reCaptchaToken, setReCaptchaToken] = React.useState<string>("");
  const [isCaptchaValid, setIsCaptchaValid] = React.useState<boolean>(true);
  const [isProcessing, setIsProcessing] = React.useState<boolean>(false);
  const [canCreateNewRequest, setCanCreateNewRequest] = React.useState<boolean>(false);
  const [showInReviewMsg, setShowInReviewMsg] = React.useState<boolean>(false);
  const refReCaptchaRegister = React.createRef<ReCAPTCHA>();
  const [showSpinner, setShowSpinner] = React.useState<boolean>(false);
  const [showInSubmissionMessage, setShowInSubmissionMessage] = React.useState<boolean>(false);
  const [purposes, setPurposes] = React.useState<IDropdownOption[]>([]);
  const [allRequestPurposes, setAllRequestPurposes] = React.useState<any[]>([]);

  React.useEffect(() => {
    (async () => {
      const dataClone: IAskAccess = cloneDeep(data);
      const firstName = props.currentUser.firstName || "";
      const lastName = props.currentUser.lastName || "";
      dataClone.Name.value = firstName + " " + lastName;
      dataClone.EMail.value = props.currentUser.email || "";
      let canCreateNewRequest = false;
      let showInReviewMsg = false;
      let currentRequestStatus = "";

      const [requestPurposesResponse, response] = await Promise.all([
        props.dataProvider.getRequestPurposes(),
        props.dataProvider.getUserData(props.currentUser.userId),
      ]);
      if (response) {
        canCreateNewRequest = response["canCreateNewRequest"] ? response["canCreateNewRequest"] : false;
        currentRequestStatus = response["currentRequestStatus"] ? response["currentRequestStatus"] : "";
      }

      if (currentRequestStatus == "AccessApproved") {
        props.history.push(PageURL.Download);
      }

      if (!canCreateNewRequest && currentRequestStatus == "DocumentSubmitted") {
        showInReviewMsg = true;
      }
      if (!canCreateNewRequest && currentRequestStatus == "AskForAccess") {
        // props.history.push(PageURL.SubmitAgreement + "/" + props.currentUser.userId);
        props.history.push(PageURL.Welcome);
      }

      if (requestPurposesResponse && requestPurposesResponse.length > 0) {
        const purposeOptions: IDropdownOption[] = requestPurposesResponse.map((purpose: any) => {
          return { key: purpose.title, text: purpose.title };
        });
        setAllRequestPurposes(requestPurposesResponse);
        setPurposes(purposeOptions);
      }

      setData(dataClone);
      setCanCreateNewRequest(canCreateNewRequest);
      setShowInReviewMsg(showInReviewMsg);
    })();
  }, []);

  const handleTextFieldChange = (fieldName: string, value: string) => {
    const dataClone: any = cloneDeep(data);
    dataClone[fieldName].value = value;
    setData(dataClone);
  };

  const handleCheckBoxChange = (fieldName: string, value: boolean) => {
    const dataClone: any = cloneDeep(data);
    if (value) {
      dataClone[fieldName].value = "Yes";
    } else {
      dataClone[fieldName].value = "";
    }
    setData(dataClone);
  };

  const validateFormFields = () => {
    setIsProcessing(true);

    let formValid = true;
    let captchaValid = true;
    const dataClone: any = cloneDeep(data);
    Object.keys(dataClone).forEach((field) => {
      if (dataClone[field].required) {
        if (dataClone[field].hasOwnProperty("value") && dataClone[field].value != null && dataClone[field].value != "") {
          dataClone[field].valid = true;
        } else {
          dataClone[field].valid = false;
          formValid = false;
        }
      }
    });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //validate first signer email and second signer email if exist
    if (dataClone.FirstSignerEmail.value) {
      if (!emailRegex.test(dataClone.FirstSignerEmail.value)) {
        dataClone.FirstSignerEmail.valid = false;
        formValid = false;
      }
    }
    if (dataClone.SecondSignerEmail.value) {
      if (!emailRegex.test(dataClone.SecondSignerEmail.value)) {
        dataClone.SecondSignerEmail.valid = false;
        formValid = false;
      }
    }

    if (reCaptchaToken == "") {
      captchaValid = false;
      formValid = false;
    }
    setData(dataClone);
    if (!formValid) {
      setIsProcessing(false);
    }

    setIsCaptchaValid(captchaValid);
    return formValid;
  };

  const onRegisterBtnCLicked = () => {
    setShowSpinner(true);
    const isFormValid = validateFormFields();
    if (isFormValid) {
      const accessRequestData: Partial<IAccessRequest> = {};
      const dataClone: IAskAccess = cloneDeep(data);
      Object.keys(dataClone).forEach((field) => {
        if (field != "FirstName" && field != "LastName") {
          (accessRequestData as any)[field] = (dataClone as any)[field].value;
        }
        if (field == "RequestPurpose") {
          const selectedPurpose = allRequestPurposes.find((purpose) => purpose.title === (dataClone as any)[field].value);
          if (selectedPurpose) {
            selectedPurpose.autoReject ? (accessRequestData.AutoReject = true) : (accessRequestData.AutoReject = false);
          } else {
            accessRequestData.AutoReject = false;
          }
        }
      });
      accessRequestData.Name = dataClone.Name.value;
      accessRequestData.UserId = props.currentUser.userId;
      props.dataProvider
        .createAccessRequest(accessRequestData)
        .then(async (result: any) => {
          setShowSpinner(false);
          setCanCreateNewRequest(false);
          setShowInReviewMsg(false);
          setShowInSubmissionMessage(true);
        })
        .catch((error) => {
          console.log(error);
          setCanCreateNewRequest(true);
          setShowInReviewMsg(false);
          setShowSpinner(false);
        });
    } else {
      setShowSpinner(false);
      setCanCreateNewRequest(true);
    }
  };

  return (
    <div className={showInReviewMsg || showInSubmissionMessage ? "appRouteShell appRouteShellCentered" : "appRouteShell"}>
      {canCreateNewRequest && (
        <Stack className={css("fullWidth", "proposalContainer", "appRouteSurface", "appRouteSurfaceWide", "animate", "popIn")} tokens={{ childrenGap: 24 }}>
          <Dialog
            hidden={!showSpinner}
            dialogContentProps={{
              type: DialogType.normal,
            }}
            modalProps={{ isBlocking: true, className: "busyOverlay" }}
          >
            <Spinner size={SpinnerSize.large} label="Working on it..." ariaLive="assertive" />
          </Dialog>
          <div className="appRouteHeader">
            <h1 className="appRouteTitle">Ask for access</h1>
            <p className="appRouteLead">Provide your company details and request purpose so Straumann can review and send the agreement workflow.</p>
          </div>
          <RequesterData
            data={data}
            onCheckBoxChange={handleCheckBoxChange}
            onTextFieldChange={handleTextFieldChange}
            readonly={false}
            requestPurposes={purposes}
          ></RequesterData>

          <CaptchaAndSubmitAction
            onRecaptchaToken={setReCaptchaToken}
            onButtonClicked={onRegisterBtnCLicked}
            refReCaptchaRegister={refReCaptchaRegister}
            isCaptchaValid={isCaptchaValid}
            isSubmitProcessing={isProcessing}
            buttonTitle="Send me the agreement"
          />
        </Stack>
      )}
      {showInReviewMsg && (
        <Stack className={css("appRouteSurface", "appRouteSurfaceNarrow", "appRouteStatusSurface", "animate", "popIn")} tokens={{ childrenGap: 14 }}>
          <h1 className="appRouteTitle">Request in review</h1>
          <p className="appRouteStatusMessage">Your current request is in review. Straumann will notify you as soon as the review is complete.</p>
        </Stack>
      )}
      {showInSubmissionMessage && (
        <Stack className={css("appRouteSurface", "appRouteSurfaceNarrow", "appRouteStatusSurface", "animate", "popIn")} tokens={{ childrenGap: 14 }}>
          <h1 className="appRouteTitle">Request submitted</h1>
          <p className="appRouteStatusMessage">Your request was submitted successfully. The agreement email may take a moment to arrive.</p>
        </Stack>
      )}
    </div>
  );
};
